import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'

const BOX_HOW_IT_WORKS_BASE = [
  'Link a Box folder to any client in Zocks',
  'Save generated PDFs - meeting summaries, meeting prep, forms - straight to Box',
  'Keep client documents organized across both platforms',
  'Browse and upload files from Box directly in Zocks',
]

const BOX_HOW_IT_WORKS_ULTIMATE = [
  'Pull documents from Box into Zocks for processing - no manual uploads needed',
  'Save document summaries to Box',
  'Work from your existing Box library without leaving the platform',
]

export const BoxHowItWorks: React.FC = () => {
  const { hasQuota } = useZocksQuota()
  const documentIntelligenceEnabled = hasQuota('ai.documentSummaryAgent.value')
  const lines = documentIntelligenceEnabled ? [...BOX_HOW_IT_WORKS_BASE, ...BOX_HOW_IT_WORKS_ULTIMATE] : BOX_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
